import { useReducer } from 'react';

export function useLoading<T>(state: T) {
  return useReducer((s: T, p: Partial<T>) => ({ ...s, ...p }), state);
}
